import { Badge, Drawer, Group, Stack } from '@mantine/core'
import { IconBulb } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'
import { WorkspaceApiKey } from '@/types/workspace'
import { getScopeConfig } from './apiKeyUtils'

type ApiKeyExampleDrawerProps = {
  apiKey: WorkspaceApiKey
  opened: boolean
  onClose: () => void
}

export const ApiKeyExampleDrawer = ({
  apiKey,
  opened,
  onClose
}: ApiKeyExampleDrawerProps) => {
  const { ExampleComponent } = getScopeConfig(apiKey.scope)

  return (
    <Drawer
      opened={opened}
      title={<FormattedMessage id="workspace.apiKeys.example.title" />}
      position="right"
      size="xl"
      onClose={onClose}
    >
      <Stack gap="xl">
        <ExampleComponent keyValue="YOUR_API_KEY" />

        {apiKey.applications && apiKey.applications.length > 0 && (
          <PlatformAlert variant="info" icon={<IconBulb />}>
            <Stack gap="md">
              <FormattedMessage id="workspace.apiKeys.example.applicationsInfo" />

              <Group gap="xs">
                {apiKey.applications.map((app) => (
                  <Badge key={app.id} size="md" variant="default">
                    {app.name}
                  </Badge>
                ))}
              </Group>
            </Stack>
          </PlatformAlert>
        )}
      </Stack>
    </Drawer>
  )
}
